module.exports = __webpack_public_path__ + "static/media/p18.ea23353c.jpeg";